module.exports = __webpack_public_path__ + "img/sardynia.b50b64bf.webp";